import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import { Outlet } from "react-router-dom";

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

   // 🔥 Disable scroll when sidebar is open
   useEffect(() => {
  if (sidebarOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
}, [sidebarOpen]);


  return (
    // <div className="flex">
    <div className={`flex ${sidebarOpen ? "" : ""}`}>


      {/* SIDEBAR */}
      <AdminSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* MAIN CONTENT */}
      <div className="flex-1 overflow-visible">

        {/* Mobile Top Bar */}
      <div className="md:hidden mt-[86px] w-full flex justify-between items-center p-4 shadow
       bg-[#895712] text-white border-b-2 border-t-2 border-blue z-20 absolute top-0">

          <h1 className="font-brand text-blue font-bold text-2xl ">Admin Panel</h1>

          {/* Mobile Toggle Button */}
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="border p-[2px]">
            <i
              className={`fa-solid text-blue ${
                sidebarOpen ? "fa-xmark" : "fa-bars"
              } text-2xl`}
            ></i>
          </button>
        </div>
            <div className=" md:mt-2">

        <Outlet />
            </div>
      </div>
    </div>
  );
}
